export const GET_AUDIT_LISTING = "GET_AUDIT_LISTING";
export const SET_AUDIT_QUESTIONNAIRE_DETAIL = "SET_AUDIT_QUESTIONNAIRE_DETAIL";
export const SET_QUERY = "SET_QUERY";
export const SET_ERROR_CODE = "SET_ERROR_CODE";
export const SET_MULTIPLE_CAMERA = "SET_MULTIPLE_CAMERA";
